import _ from 'lodash';
import moment from 'moment';
import {ISearchVehicle as IVehicle} from '../interface';

class Filter {
  _vehicles: IVehicle[];
  constructor(vehicles: IVehicle[]) {
    this._vehicles = vehicles;
  }
  vehicleType(vehicleType: string | undefined) {
    vehicleType &&
      (this._vehicles = _.filter(this._vehicles, ['vehicleType', vehicleType]));
    return this;
  }
  manufacturer(manufacturer: string | undefined) {
    manufacturer &&
      (this._vehicles = _.filter(this._vehicles, ['make', manufacturer]));
    return this;
  }
  model(model: string | undefined) {
    model && (this._vehicles = _.filter(this._vehicles, ['model', model]));
    return this;
  }
  year(year: string | undefined) {
    if (_.isEmpty(year)) {
      return this;
    }
    this._vehicles = _.filter(this._vehicles, (v) => {
      const range = [
        moment(v['yearFrom'], 'YYYY'),
        !_.isNull(v['yearTo']) ? moment(v['yearTo'], 'YYYY') : moment(),
      ];
      return moment(year, 'YYYY').isBetween(range[0], range[1], 'years', '[]');
    });
    return this;
  }
  value() {
    return this._vehicles;
  }
}

export default Filter;
